/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type UpdateKnowledgeDocumentBodyStatus = typeof UpdateKnowledgeDocumentBodyStatus[keyof typeof UpdateKnowledgeDocumentBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateKnowledgeDocumentBodyStatus = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;
